import { useInvalidateAllShopEmailTemplates } from "./use-get-all-shop-email-templates";
import { useApiMutation } from "./use-api-mutation";

/**
 * Reset a return email template to its packaged default (content/subject/preview).
 * Only works for templates carrying an `emailDefaultTemplateType`.
 */
export default function useResetEmailTemplate(shopId: string) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/email-templates/{templateId}/reset",
		{
			invalidate: [useInvalidateAllShopEmailTemplates(shopId)],
			mapVariables: (templateId: string) => ({
				params: { path: { shopId, templateId } },
			}),
		},
	);
}
